export const pageTitles = {
  loadingPartners: "Sit tight, we're getting you the best rates from our partners - Zopa",
  quoteDoesntExist: "We're sorry, but this quote doesn't seem to exist - Zopa",
  sitTight: "Sit tight, we're getting your very own quote - Zopa",
  quoteExpired: "We're sorry, but your quote has expired - Zopa",
  success: "You've been pre-approved for these loans - Zopa",
  sorry: "Sorry, we can't offer you a loan today - Zopa",
  selectLoan: "You're pre-approved for a loan! - Zopa",
  partners: 'Get a loan with our partners - Zopa',
  cancelled: "Sorry, we can't continue - Zopa",
  error500: 'Something went wrong - Zopa',
  error404: 'Page not found - Zopa',
} as const;
